import { BrowserRouter } from "react-router-dom";
import PageRoutes from "./Router";

const App = () => {
  return (
    <BrowserRouter>
      <PageRoutes />
    </BrowserRouter>
  );
};

export default App;
